export default __webpack_public_path__ + "static/media/050-fairytale.b091b312.svg";